import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "../../components";
import { CHANGE_INITIAL_PASSWORD_URL } from "../../features/UrlHelper";
import { useAuth } from "../../context/AuthContext";
import { getPendingUsername, clearPendingUsername } from "../../features/tenantStorage";
import "./SetupPassword.scss";

// Rovnako ako server (services/passwords.js, MIN_DLZKA_HESLA). Bolo tu 6 --
// heslo so 6-7 znakmi preslo formularom a server ho az potom odmietol.
const MIN_HESLO = 8;

function SetupPassword() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [username, setUsername] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const pending = getPendingUsername();
    if (!pending) {
      navigate("/", { replace: true });
      return;
    }
    setUsername(pending);
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    if (newPassword !== confirmPassword) {
      setErrorMessage("Nové heslá sa nezhodujú.");
      return;
    }
    if (newPassword.length < MIN_HESLO) {
      setErrorMessage(`Nové heslo musí mať aspoň ${MIN_HESLO} znakov.`);
      return;
    }

    setIsSubmitting(true);
    try {
      const res = await axios.post(CHANGE_INITIAL_PASSWORD_URL, {
        username,
        oldPassword,
        newPassword,
      });

      clearPendingUsername();
      login(res.data);

      const role = res.data.role;
      if (role === "ADMIN" || role === "SUPERADMIN" || role === "MANAGER") {
        navigate("/admin", { replace: true });
      } else if (role === "DRIVER") {
        navigate("/vodic", { replace: true });
      } else {
        navigate("/profil", { replace: true });
      }
    } catch (err) {
      setErrorMessage(
        err.response?.data?.message || "Nastala chyba pri zmene hesla."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="setup-password">
      <div className="setup-password__card">
        <h1 className="setup-password__title">Nastavenie hesla</h1>
        <p className="setup-password__subtitle">
          Pri prvom prihlásení musíte zmeniť dočasné heslo. Zadajte dočasné heslo,
          ktoré ste dostali od administrátora, a zvoľte si nové trvalé heslo.
        </p>

        <form className="setup-password__form" onSubmit={handleSubmit}>
          <div className="setup-password__field">
            <label className="setup-password__label" htmlFor="sp-old-password">
              Dočasné heslo
            </label>
            <input
              id="sp-old-password"
              type="password"
              className="setup-password__input"
              placeholder="Dočasné heslo od administrátora"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>

          <div className="setup-password__field">
            <label className="setup-password__label" htmlFor="sp-new-password">
              Nové heslo
            </label>
            <input
              id="sp-new-password"
              type="password"
              className="setup-password__input"
              placeholder={`Minimálne ${MIN_HESLO} znakov`}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete="new-password"
              required
            />
          </div>

          <div className="setup-password__field">
            <label className="setup-password__label" htmlFor="sp-confirm-password">
              Potvrdiť nové heslo
            </label>
            <input
              id="sp-confirm-password"
              type="password"
              className="setup-password__input"
              placeholder="Zopakujte nové heslo"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              autoComplete="new-password"
              required
            />
          </div>

          {errorMessage && (
            <div className="setup-password__error">{errorMessage}</div>
          )}

          <Button
            variant="primary"
            type="submit"
            disabled={isSubmitting}
            style={{ width: "100%" }}
          >
            {isSubmitting ? "Ukladám..." : "Nastaviť heslo a prihlásiť sa"}
          </Button>
        </form>
      </div>
    </div>
  );
}

export default SetupPassword;
